module.exports = __webpack_public_path__ + "img/icon-sksit.a0a3b2ce.svg";